import React, { useState, useEffect } from "react";
import {  InputBase, Select, MenuItem } from '@material-ui/core';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from 'react-bootstrap/ModalHeader';
import ModalBody from 'react-bootstrap/ModalBody';
import { Container, Footer } from './styles';
import { ModalFooter } from "react-bootstrap";
import { useStyles } from './styles';
import { exceptionNotificationAPI } from "../../services/api";
import { height } from "@mui/system";

export default function ModalFormFaturamento({ setShow, fnExport, cropYears, ...props }) {
  const styles = useStyles();
  const [exportType, setExportType] = useState("P");
  const [searchText, setSearchText] = useState("");  
  const [selectedCropYear, setSelectedCropYear] = useState(new Date().getFullYear());
  const [cropYear, setCropYear] = useState();

   useEffect(() => {
      console.log("-> " + new Date().getFullYear());
      setSelectedCropYear(new Date().getFullYear())
   }, [cropYears]);

   
  const validExport = () => {
    if (exportType == "O" && searchText == ""){
      exceptionNotificationAPI("Por favor, preencha o campo Ordem de Serviço!");
      return false;
    }
    console.log("-> " + selectedCropYear);
    fnExport(exportType, searchText, selectedCropYear)
  }

  return (
    <Modal
      {...props}
      centered
      onHide={() => {
        setShow(false)
      }}
    >
      <ModalHeader closeButton>
        <Container>
          <label className="title">Gerar relatório de Faturamento</label>
        </Container>
      </ModalHeader>
      <ModalBody >
        <Container>
          <label className="field">Selecione abaixo os dados que você deseja imprimir:</label>
          <select name='exportType' value={exportType} className={styles.search} onChange={(e) => { setExportType(e.target.value) }}>
              <option value="P">Pendentes Faturamento</option>
              <option value="O">Ordem de Serviço</option>
          </select>

        {exportType == "O" && <label className="field">Ano: </label>}
          {exportType == "O" && <select name='OSYear' value={selectedCropYear}  className={styles.search} onChange={(e) => {
                                    setSelectedCropYear(e.target.value)
                                  }}>
                                    {
                                      cropYears ?
                                        cropYears.map(cropYear => {
                                          return <option key={cropYear} value={cropYear}>{cropYear}</option>
                                        })
                                        :
                                        <></>
                                    }
                                  </select> }

          {exportType == "O" && <label className="field">Você pode inserir mais de uma Ordem de Serviço separadas por vírgula.</label>}
          {exportType == "O" && <InputBase className={styles.search} value={searchText} placeholder={"Ordem de Serviço"} style={{ background: "white" }} onChange={(e) => {setSearchText(e.target.value)}}/>}

          


          
        </Container>
      </ModalBody>
      <ModalFooter>
        <Footer>
          <div className="row div-footer">
            <button className="btn button-cancel" onClick={() => {
              setShow(false)
            }} >Cancelar</button>
            <button className="btn button-confirm" onClick={() => { validExport() }} >Exportar</button>
          </div>
        </Footer>
      </ModalFooter>
    </Modal>
  );
}